import { ByEntityId } from '@upright/common/model/input/types';
import { KTAttr, KTTag } from './types';

export function getKTEntity(id: string, name: string | undefined) {
  return `<${KTTag.Entity} ${KTAttr.ID}="${id}">${name}</${KTTag.Entity}>`;
}

export function getKTImpact(friendlyImpactCategory: string) {
  return `<${KTTag.IMPACT}>${friendlyImpactCategory}</${KTTag.IMPACT}>`;
}

export function getKTValueSet(valueSetText: string | undefined) {
  return `<${KTTag.VALUE_SET}>${valueSetText}</${KTTag.VALUE_SET}>`;
}

export function getItemList(showcaseItemIds: string[], namesById: ByEntityId<string | undefined>) {
  return showcaseItemIds
    .map((id, index) => {
      const name = namesById[id];
      if (showcaseItemIds.length === 1) {
        return getKTEntity(id, name);
      }

      if (index === showcaseItemIds.length - 1) {
        return `and ${getKTEntity(id, name)}`;
      }

      if (showcaseItemIds.length === 2) {
        return `${getKTEntity(id, name)} `;
      }
      return `${getKTEntity(id, name)}, `;
    })
    .join('');
}

// Strips the <> and </> tags, leaving just the value
export function removeTagsFromKeyTakeawayString(input: string, replaceValue: string = '') {
  return input.replace(/<[^>]*>/g, replaceValue);
}
